import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import './GdsRcptRtnDetailBoardKanban.css';

import { List } from 'antd';
import { Card, Badge } from 'react-bootstrap';

import GdsRcptRtnDetailBoardActions from '../../Stores/GdsRcptRtnDetailBoard/Actions';

class WipWhseJobTable extends React.PureComponent {
  constructor() {
    super();

    this.renderItem = this.renderItem.bind(this);
    this.useOnListChange = this.useOnListChange.bind(this);
  }

  componentDidMount() {
    const { curSiteFlowId, resetTimestamp } = this.props;

    if (curSiteFlowId > 0) {
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchWipWhseJob, currentPage, sorts, filters, pageSize } = this.props;
    const { resetTimestamp } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestamp();
    }

    if (changed('timestamp')) {
      if (curSiteFlowId > 0) {
        fetchWipWhseJob(currentPage, sorts, filters, pageSize);
      }
    }
  }

  componentWillUnmount() {}

  handleSearch(selectedKeys, confirm) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    confirm();
  }

  handleReset(clearFilters) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    clearFilters();
  }

  useOnListChange(page, pageSize) {
    const { resetTimestamp, sorts, filters } = this.props;

    resetTimestamp(page, sorts, filters, pageSize);
  }

  renderItem(record) {
    const { intl, showWipWhseJobSummary } = this.props;

    let color = 'badge-default'; // red
    if (record.doc_date_aging < 1) {
      color = 'badge-green'; // green
    } else if (record.doc_date_aging < 2) {
      color = 'badge-lime'; // lime
    } else if (record.doc_date_aging < 3) {
      color = 'badge-yellow'; // yellow
    } else if (record.doc_date_aging < 4) {
      color = 'badge-gold'; // gold
    } else if (record.doc_date_aging < 5) {
      color = 'badge-orange'; // orange
    } else if (record.doc_date_aging < 6) {
      color = 'badge-pink'; // pink
    }

    return (
      <Card className="rowcard" key={record.id} onClick={() => showWipWhseJobSummary(record.id)}>
        <Card.Header>{`${record.shipping_doc_code} ${record.doc_code}`}</Card.Header>
        <Card.Body>
          <div className="progressinfo">
            <div>
              <h4>
                <Badge className={color}>{record.doc_date_aging}</Badge>
              </h4>
              <h6 className="daypassed">
                day(s)
                <br />
                passed
              </h6>
            </div>
            <div>
              <Card.Title className="infotext" style={{ fontSize: '15px', wordBreak: 'break-all' }}>
                {record.to_storage_bin_code}
                <br />
                {record.areas.map(value => (
                  <span key={`${record.id}:${value.code}`}>{` ${value.code}`}</span>
                ))}
              </Card.Title>
              <Card.Subtitle className="infotext text-muted" style={{ fontSize: '15px' }}>
                {`${record.str_doc_status} ${record.worker_01_username}`}
              </Card.Subtitle>
              <Card.Text className="infotext">
                <b>{record.whse_job_type_label}</b>
                {record.delivery_points.map((value, index) => (
                  <span key={`${record.id}:${value.code}`}>
                    <br />
                    <b>{`${index + 1} `}</b>
                    {value.company_name_01}
                  </span>
                ))}
              </Card.Text>
            </div>
          </div>
        </Card.Body>
        <Card.Footer>
          <small className="datetime">{record.created_at}</small>
          <small className="lineno">
            {`${record.ttl_line_no} ${intl.formatMessage({ id: 'lines' })}`}
          </small>
        </Card.Footer>
      </Card>
    );
  }

  render() {
    const { intl, currentPage, pageSize, total, documents, fetchIsLoading } = this.props;

    return (
      <Card className="columncard" text="dark">
        <Card.Header className="wipwhsejob">
          {`${total} ${intl.formatMessage({ id: 'mobile_jobs' })}`}
        </Card.Header>
        <Card.Body className="scr">
          <List
            loading={fetchIsLoading}
            itemLayout="horizontal"
            dataSource={documents}
            renderItem={this.renderItem}
            pagination={{
              current: currentPage,
              pageSize: parseInt(pageSize, 10),
              total,
              size: 'small',
              simple: 'simple',
              onChange: this.useOnListChange
            }}
          />
        </Card.Body>
      </Card>
    );
  }
}

WipWhseJobTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  resetTimestamp: PropTypes.func,

  documents: PropTypes.arrayOf(PropTypes.object),

  sorts: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  filters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),

  currentPage: PropTypes.number,
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.number,
  fetchIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchWipWhseJob: PropTypes.func,

  showWipWhseJobSummary: PropTypes.func
};

WipWhseJobTable.defaultProps = {
  intl: {},
  resetTimestamp() {},
  documents: [],

  sorts: {},
  filters: {},

  currentPage: 1,
  pageSize: '20',
  total: 0,
  fetchIsLoading: false,

  curSiteFlowId: 0,
  fetchWipWhseJob() {},

  showWipWhseJobSummary() {}
};

const mapStateToProps = state => ({
  timestamp: state.gdsRcptRtnDetailBoard.wipWhseJobTimestamp,

  documents: state.gdsRcptRtnDetailBoard.wipWhseJobs,

  sorts: state.gdsRcptRtnDetailBoard.wipWhseJobSorts,
  filters: state.gdsRcptRtnDetailBoard.wipWhseJobFilters,

  currentPage: state.gdsRcptRtnDetailBoard.wipWhseJobCurrentPage,
  pageSize: state.gdsRcptRtnDetailBoard.wipWhseJobPageSize,
  total: state.gdsRcptRtnDetailBoard.wipWhseJobTotal,
  fetchIsLoading: state.gdsRcptRtnDetailBoard.wipWhseJobIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  resetTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptRtnDetailBoardActions.gdsRcptRtnDetailBoardResetWipWhseJobTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),

  fetchWipWhseJob: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      GdsRcptRtnDetailBoardActions.gdsRcptRtnDetailBoardFetchWipWhseJob(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),

  showWipWhseJobSummary: docId =>
    dispatch(GdsRcptRtnDetailBoardActions.gdsRcptRtnDetailBoardShowWipWhseJobSummary(docId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WipWhseJobTable));
